<template>
<div class="mr15">
  <sui-page-contents>
    <sui-grid ref="grid" :columns="gridColumns0" :dataset="'dataset0'" :labelMode="labelMode" :filterable="true" :sortable="true">
    </sui-grid>
    <div class="row" style="height:40px">
      <div class="col-xs-2">
        <button type="button" class="comm_btn_scr" @click="onClickAdd">
        추가</button>
      </div>      
      <div class="col-xs-2">
        <button type="button" class="comm_btn_scr" @click="onClickUp">
        위로</button>
      </div>
      <div class="col-xs-2">
        <button type="button" class="comm_btn_scr" @click="onClickDown">
        아래로</button>
      </div>
      <div class="col-xs-2">
        <button type="button" class="comm_btn_scr" @click="onReset">
        리셋</button>
      </div>
    </div>
    <sui-grid ref="grid2" :columns="gridColumns1" :dataset="'dataset1'" :sortable="true" />
    <div style="display: flex">
      <ul class="my-list">
        <li>added rows</li>
        <li v-for="item in addedRows">{{getText(item)}}</li>
      </ul>
      <ul class="my-list">
        <li>removed rows</li>
        <li v-for="item in removedRows">{{getText(item)}}</li>
      </ul>
      <ul class="my-list">
        <li>changed rows</li>
        <li v-for="item in updatedRows">{{getText(item)}}</li>
      </ul>
    </div>
  </sui-page-contents>
</div>
</template>
<script>

import LangSelect from '~common/components/form/SuiLangSelect/SuiLangSelect';
export default {
  name: 'DatasetWithComponent',
  data() {
    return {
      addedRows: [],
      removedRows: [],
      updatedRows: [],
      labelMode: false,
      rangeDate: "20190510125916~99991231235959",
      cellEditorMap: {},
      customOpitonList: [{
        key: '',
        label: 'AAA'
      }, ],
      selected: {
        md: {
          key: '',
          label: ''
        },
        smd: {
          key: '',
          label: ''
        },
        code: {
          key: '',
          label: ''
        },
        lang: {
          key: '',
          label: ''
        },
        yn: {
          key: '',
          label: ''
        },
        custom: {
          key: '개발',
          label: ''
        },
        customlang: {
          key: '',
          label: ''
        },
      },
      customOptions: [{
          key: 'D',
          label: '개발'
        },
        {
          key: 'F',
          label: '완료'
        },
      ],
      mdDisabled: false,
      pageName: '',
      pagePopupYn: '',
      checked: false,
      gridColumns0: [
        {
            text: 'rowId',
            datafield: 'dataset-row-id',
            width: '50px',
        },        
        {
          text: '페이지 명',
          datafield: 'pageName',
          createwidget: (row, column, value, htmlElement) => {
            const editorInstance = utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
              trim: true,
            }, this.dataset0, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        },
        {
          text: '페이지 상태',
          datafield: 'pageStatusCode',
          createwidget: (row, column, value, htmlElement) => {
            const editorInstance = utils.getGridCellFactory().createCellSelect(row, column, value, htmlElement, {
              optionList: this.customOptions,
            }, this.dataset0, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        },
        {
          text: '사용여부',
          datafield: 'pageUseYn',
          createwidget: (row, column, value, htmlElement) => {
            const editorInstance = utils.getGridCellFactory().createCellSegmentBox(row, column, value, htmlElement, {}, this.dataset0, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        },
        {
          text: '추가',
          datafield: 'addrow',
          createwidget: (row, column, value, htmlElement) => {
            const editorInstance = utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
              handler: this.onAddRow,
            }, this.dataset0, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
          width: 150,
        },
        {
          text: '삭제',
          datafield: 'removerow',
          createwidget: (row, column, value, htmlElement) => {
            const editorInstance = utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
              handler: this.onRemoveRow,
            }, this.dataset0, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },         
          width: 150,   
        },      
      ],
      gridColumns1: [
        {
            text: 'rowId',
            datafield: 'dataset-row-id',
            width: '50px',
        },        
        {
          text: '페이지 명',
          datafield: 'pageName',
          createwidget: (row, column, value, htmlElement) => {
            const editorInstance = utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
              trim: true,
            }, this.dataset0, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        },
        {
          text: '페이지 상태',
          datafield: 'pageStatusCode',
          createwidget: (row, column, value, htmlElement) => {
            const editorInstance = utils.getGridCellFactory().createCellSelect(row, column, value, htmlElement, {
              optionList: this.customOptions,
            }, this.dataset0, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        },
        {
          text: '사용여부',
          datafield: 'pageUseYn',
          createwidget: (row, column, value, htmlElement) => {
            const editorInstance = utils.getGridCellFactory().createCellSegmentBox(row, column, value, htmlElement, {}, this.dataset0, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        },
        {
          text: '추가',
          datafield: 'addrow',
          createwidget: (row, column, value, htmlElement) => {
            const editorInstance = utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
              handler: this.onAddRow,
            }, this.dataset0, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
          width: 150,
        },
        {
          text: '삭제',
          datafield: 'removerow',
          createwidget: (row, column, value, htmlElement) => {
            const editorInstance = utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
              handler: this.onRemoveRow,
            }, this.dataset0, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },         
          width: 150,   
        },      
      ],
      initialData: {
        "deleteYn": "Y",
        "firstRegistrationDTM": "20190510125920",
        "firstRegistrationUserId": "chiwoo.seo",
        "firstRegistrationProgramId": "PGE_CMU_00001",
        "finalModificationDTM": "2019-05-10 12:59:20",
        "finalModificationUserId": "chiwoo.seo",
        "finalModificationProgramId": "PGE_CMU_00001",
        "pageId": "PGE_CMS_00000",
        "moduleCode": "CM",
        "subModuleCode": "S",
        "pageName": "신규",
        "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
        "pageTypeCode": "N",
        "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
        "pageStatusCode": "D",
        "pageBlockContent": "차단된 페이지입니다.",
        "pageUseYn": "Y",
        "pageUsePriodYn": "N",
        "pageUsePriodStartDatetime": "2019-05-10",
        "pageUsePriodFinishDatetime": "9999-12-31",
        "pagePopupYn": "N",
        "pagePopupOptionValue": null,
        "searchPageCond": null,
        "searchPageText": null,
        "lang": 'en',
        'rangeDate': '2019-01-10~2019-02-15',
        'buttonList': [{
          label: 'btn01',
          key: 'btn01',
          type: 'positive'
        }, {
          label: 'btn02',
          key: 'btn02',
          type: 'negative'
        }, {
          label: 'btn01',
          key: 'btn02',
          type: 'negative'
        }],
        'time': '11:52',
        'state': {
          type: 'complete',
          label: '완료'
        },
        'multiselect': ['item01', 'item02'],
        'addrow': 'add row',
        'removerow': 'remove row',
      },
      localdata1: [],
      localdata0: [{
          "deleteYn": "Y",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00001",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00001",
          "pageId": "PGE_CMS_00000",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "2019-05-10",
          "pageUsePriodFinishDatetime": "9999-12-31",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
          'rangeDate': '2019-01-10~2019-02-15',
          'buttonList': [{
            label: 'btn01',
            key: 'btn01',
            type: 'positive'
          }, {
            label: 'btn02',
            key: 'btn02',
            type: 'negative'
          }, {
            label: 'btn01',
            key: 'btn02',
            type: 'negative'
          }],
          'time': '11:52',
          'state': {
            type: 'complete',
            label: '완료'
          },
          'multiselect': ['item01', 'item02'],
          'addrow': 'add row',
          'removerow': 'remove row',
        },
        {
          "deleteYn": "Y",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00003",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00003",
          "pageId": "PGE_CMS_00001",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "N",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "2019-05-11",
          "pageUsePriodFinishDatetime": "9999-12-30",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
          'rangeDate': '2019-01-11~2019-02-16',
          'buttonList': [{
            label: 'btn21',
            key: 'btn01',
            type: 'positive'
          }, {
            label: 'btn22',
            key: 'btn02',
            type: 'negative'
          }, {
            label: 'btn23',
            key: 'btn02',
            type: 'negative'
          }],
          'time': '12:12',
          'state': {
            type: 'waiting',
            label: '대기'
          },
          'multiselect': ['item01', 'item03'],
          'addrow': 'add row',
          'removerow': 'remove row',
        },
        {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00005",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00005",
          "pageId": "PGE_CMS_00002",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "2019-05-13",
          "pageUsePriodFinishDatetime": "9999-12-30",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
          'rangeDate': '2019-01-12~2019-02-17',
          'buttonList': [{
            label: 'btn33',
            key: 'btn01',
            type: 'positive'
          }, {
            label: 'btn32',
            key: 'btn02',
            type: 'negative'
          }, {
            label: 'btn01',
            key: 'btn02',
            type: 'negative'
          }],
          'time': '14:52',
          'state': {
            type: 'cancel',
            label: '취소'
          },
          'multiselect': ['item02', 'item04'],
          'addrow': 'add row',
          'removerow': 'remove row',
        },
        {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00002",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00002",
          "pageId": "PGE_CMS_00003",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "N",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "2019-05-14",
          "pageUsePriodFinishDatetime": "9999-12-30",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
          'rangeDate': '2019-01-14~2019-02-18',
          'buttonList': [{
            label: 'btn44',
            key: 'btn01',
            type: 'positive'
          }, {
            label: 'btn42',
            key: 'btn02',
            type: 'negative'
          }, {
            label: 'btn01',
            key: 'btn02',
            type: 'negative'
          }],
          'time': '17:17',
          'state': {
            type: 'complete',
            label: '완료'
          },
          'multiselect': ['item03'],
          'addrow': 'add row',
          'removerow': 'remove row',
        },
      ],
    };
  },
  mounted() {
    this.dataset0.$on(this.dataset0.EVENTS.DATA_CHANGED, this.onDatasetChanged);    
    this.dataset0.$on(this.dataset0.EVENTS.DATA_RESET, this.onDatasetChanged);
    this.dataset0.$on(this.dataset0.EVENTS.RAW_DATA_CHANGED, this.onDatasetChanged);
  },
  datasets: [{
    id: 'dataset0',
    type: 'local',
    data: 'localdata0',
    datafields: [{
        "name": "deleteYn",
        "type": "string",
        "map": "deleteYn"
      },
      {
        "name": "firstRegistrationDTM",
        "type": "string",
        "map": "firstRegistrationDTM"
      },
      {
        "name": "firstRegistrationUserId",
        "type": "string",
        "map": "firstRegistrationUserId"
      },
      {
        "name": "firstRegistrationProgramId",
        "type": "string",
        "map": "firstRegistrationProgramId"
      },
      {
        "name": "finalModificationDTM",
        "type": "string",
        "map": "finalModificationDTM"
      },
      {
        "name": "finalModificationUserId",
        "type": "string",
        "map": "finalModificationUserId"
      },
      {
        "name": "finalModificationProgramId",
        "type": "string",
        "map": "finalModificationProgramId"
      },
      {
        "name": "pageId",
        "type": "string",
        "map": "pageId"
      },
      {
        "name": "moduleCode",
        "type": "string",
        "map": "moduleCode"
      },
      {
        "name": "subModuleCode",
        "type": "string",
        "map": "subModuleCode"
      },
      {
        "name": "pageName",
        "type": "string",
        "map": "pageName"
      },
      {
        "name": "pageTitleMessageResourceId",
        "type": "string",
        "map": "pageTitleMessageResourceId"
      },
      {
        "name": "pageTypeCode",
        "type": "string",
        "map": "pageTypeCode"
      },
      {
        "name": "pageDestinationValue",
        "type": "string",
        "map": "pageDestinationValue"
      },
      {
        "name": "pageStatusCode",
        "type": "string",
        "map": "pageStatusCode"
      },
      {
        "name": "pageBlockContent",
        "type": "string",
        "map": "pageBlockContent"
      },
      {
        "name": "pageUseYn",
        "type": "string",
        "map": "pageUseYn"
      },
      {
        "name": "pageUsePriodYn",
        "type": "string",
        "map": "pageUsePriodYn"
      },
      {
        "name": "pageUsePriodStartDatetime",
        "type": "string",
        "map": "pageUsePriodStartDatetime"
      },
      {
        "name": "pageUsePriodFinishDatetime",
        "type": "string",
        "map": "pageUsePriodFinishDatetime"
      },
      {
        "name": "pagePopupYn",
        "type": "string",
        "map": "pagePopupYn"
      },
      {
        "name": "pagePopupOptionValue",
        "type": "string",
        "map": "pagePopupOptionValue"
      },
      {
        "name": "searchPageCond",
        "type": "string",
        "map": "searchPageCond"
      },
      {
        "name": "searchPageText",
        "type": "string",
        "map": "searchPageText"
      },
      {
        "name": "lang",
        "type": "string",
        "map": "lang"
      },
      {
        "name": "rangeDate",
        "type": "string",
        "map": "rangeDate"
      },
      {
        "name": "buttonList",
        "type": "object",
        "map": "buttonList"
      },
      {
        "name": "state",
        "type": "object",
        "map": "state"
      },
      {
        "name": "dataset-row-id",
        "type": "string",
        "map": "dataset-row-id"
      },
      {
        "name": "addrow",
        "type": "string",
        "map": "addrow"
      },
      {
        "name": "removerow",
        "type": "string",
        "map": "removerow"
      },
    ]
  },
  {
    id: 'dataset1',
    type: 'local',
    data: 'localdata1',
    datafields: [{
        "name": "deleteYn",
        "type": "string",
        "map": "deleteYn"
      },
      {
        "name": "firstRegistrationDTM",
        "type": "string",
        "map": "firstRegistrationDTM"
      },
      {
        "name": "firstRegistrationUserId",
        "type": "string",
        "map": "firstRegistrationUserId"
      },
      {
        "name": "firstRegistrationProgramId",
        "type": "string",
        "map": "firstRegistrationProgramId"
      },
      {
        "name": "finalModificationDTM",
        "type": "string",
        "map": "finalModificationDTM"
      },
      {
        "name": "finalModificationUserId",
        "type": "string",
        "map": "finalModificationUserId"
      },
      {
        "name": "finalModificationProgramId",
        "type": "string",
        "map": "finalModificationProgramId"
      },
      {
        "name": "pageId",
        "type": "string",
        "map": "pageId"
      },
      {
        "name": "moduleCode",
        "type": "string",
        "map": "moduleCode"
      },
      {
        "name": "subModuleCode",
        "type": "string",
        "map": "subModuleCode"
      },
      {
        "name": "pageName",
        "type": "string",
        "map": "pageName"
      },
      {
        "name": "pageTitleMessageResourceId",
        "type": "string",
        "map": "pageTitleMessageResourceId"
      },
      {
        "name": "pageTypeCode",
        "type": "string",
        "map": "pageTypeCode"
      },
      {
        "name": "pageDestinationValue",
        "type": "string",
        "map": "pageDestinationValue"
      },
      {
        "name": "pageStatusCode",
        "type": "string",
        "map": "pageStatusCode"
      },
      {
        "name": "pageBlockContent",
        "type": "string",
        "map": "pageBlockContent"
      },
      {
        "name": "pageUseYn",
        "type": "string",
        "map": "pageUseYn"
      },
      {
        "name": "pageUsePriodYn",
        "type": "string",
        "map": "pageUsePriodYn"
      },
      {
        "name": "pageUsePriodStartDatetime",
        "type": "string",
        "map": "pageUsePriodStartDatetime"
      },
      {
        "name": "pageUsePriodFinishDatetime",
        "type": "string",
        "map": "pageUsePriodFinishDatetime"
      },
      {
        "name": "pagePopupYn",
        "type": "string",
        "map": "pagePopupYn"
      },
      {
        "name": "pagePopupOptionValue",
        "type": "string",
        "map": "pagePopupOptionValue"
      },
      {
        "name": "searchPageCond",
        "type": "string",
        "map": "searchPageCond"
      },
      {
        "name": "searchPageText",
        "type": "string",
        "map": "searchPageText"
      },
      {
        "name": "lang",
        "type": "string",
        "map": "lang"
      },
      {
        "name": "rangeDate",
        "type": "string",
        "map": "rangeDate"
      },
      {
        "name": "buttonList",
        "type": "object",
        "map": "buttonList"
      },
      {
        "name": "state",
        "type": "object",
        "map": "state"
      },
      {
        "name": "dataset-row-id",
        "type": "string",
        "map": "dataset-row-id"
      },
      {
        "name": "addrow",
        "type": "string",
        "map": "addrow"
      },
      {
        "name": "removerow",
        "type": "string",
        "map": "removerow"
      },
    ]
  },
  ],
  methods: {
    getText(item) {
      return item['dataset-row-id'];
    },
    onClicked() {},
    onCodeLoaded(optionsList) {
      optionsList.push({
        key: 'N',
        label: 'NN'
      });
    },
    onDatasetChanged() {
      this.addedRows = this.dataset0.getAddedRows();
      this.removedRows = this.dataset0.getRemovedRows();
      this.updatedRows = this.dataset0.getUpdatedRows();
    },    
    onClickAdd() {
      const newRow = _.clone(this.initialData);
      this.dataset0.addRows([newRow]);
      this.$refs.grid.setFocus(this.dataset0.data.length - 1, 'pageName');
    },
    onClickUp() {
      const selectedRows = [];
      const selectedIndexes = this.dataset1.getSelectedIndexes();
      _.forEach(selectedIndexes, index => {
        selectedRows.push(_.clone(this.dataset1.data[index]));
      });
      this.dataset1.deleteRows(selectedIndexes);
      this.dataset0.addRows(selectedRows);
    },
    onClickDown() {
      const selectedRows = [];
      const selectedIndexes = this.dataset0.getSelectedIndexes();
      _.forEach(selectedIndexes, index => {
        selectedRows.push(_.clone(this.dataset0.data[index]));
      });
      this.dataset0.deleteRows(selectedIndexes);
      this.dataset1.addRows(selectedRows);
    },
    onReset() {
      this.dataset0.reset();
      this.dataset1.reset();
      utils.toast('초기화 되었습니다.');
    },
    onAddRow(button, rowData, rowIndex, columnName) {
      const newRow = _.clone(this.initialData);
      this.dataset0.addRows([newRow], rowData);
      this.$refs.grid.setFocus(rowIndex, 'pageName');
    },
    onRemoveRow(button, rowData, rowIndex, columnName) {
      this.dataset0.deleteRows([rowIndex]);
    },
  }
};
</script>

<style scoped>
.comm_btn_scr {
  width: 100px;
  height: 30px;
  background-color: #22A;
  color: white;
}
.my-list {
  width: 150px;
  border: 1px solid blue;
}
</style>
